<select class="form-control form-control-sm" [formControl]="control" [required]="required">
  <option value="{{p.id}}" *ngFor="let p of items$ | async">{{p.nombre}} [{{p.codigo}}]</option>
</select>
